import { useState } from 'react';

import { GUIDType } from '../interfaces/types';
import { useSnackbar } from 'notistack';
import { IFormValidator } from '../core/FormValidator';
import { useTranslation } from 'react-i18next';
import { ResourceTextApplication } from '../core/resources';
import shortMessagesApi from '../api/shortMessageApi';

import {
    ADialog,
    ADialogActions,
    ADialogContent,
    ADialogSubHeading,
    ADialogTitle,
    ADialogButtonsProp,
} from '../common/dialog';
import { Typography } from '@mui/material';

export interface CancelMessageDialogDialogProps {
    afterDelete: (id: GUIDType) => void;
    id: GUIDType;
    onClose: () => void;
    validator?: IFormValidator;
}

export default function CancelMessageDialog(props: CancelMessageDialogDialogProps) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { enqueueSnackbar } = useSnackbar();
    const showMessage = (message: string, variant: 'success' | 'error') => {
        enqueueSnackbar(message, {
            variant: variant,
        });
    };
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral', 'AnelmaPerson', 'AnelmaSMS']);

    const deletefooterButtons: ADialogButtonsProp = {
        left: [
            {
                type: 'cancel',
                label: t('AnelmaGeneral:1009'),
                onClick: () => props.onClose(),
            },
        ],
        right: [
            {
                type: 'delete',
                label: t('AnelmaGeneral:1012'),
                onClick: () => onDelete(props.id as string),
            },
        ],
    };

    const onDelete = (guid: GUIDType) => {
        if (props.validator?.invalid) {
            enqueueSnackbar(t('AnelmaGeneral:1030'), {
                variant: 'error',
            });
            return;
        }
        setIsLoading(true);
        shortMessagesApi.cancelMessage(guid).then((data) => {
            if (data && data.Results.HttpStatus === 202) {
                showMessage(t('AnelmaGeneral:1018'), 'success');
                props.afterDelete(props.id);
                props.onClose();
                return;
            } else {
                showMessage(t('AnelmaGeneral:1019'), 'error');
                props.onClose();
            }
        });
    };

    return (
        <>
            <ADialog open={true} onClose={() => props.onClose()}>
                <ADialogTitle>{t('AnelmaSMS:1004')}</ADialogTitle>

                <ADialogContent size='sm'>
                    <Typography className='confirm-dialog-content-typography' variant='body1'>
                        {t('AnelmaCommunication:1084')}
                    </Typography>
                </ADialogContent>
                <ADialogActions buttons={deletefooterButtons} isLoading={isLoading} />
            </ADialog>
        </>
    );
}
